module.exports = __webpack_public_path__ + "static/media/machina-bg-3.19e75f72.jpg";